<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ValueAddedServices')"
    width="1030px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view reminder-form"
    @close="close"
  >
    <div class="main-content">
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column content-wrapper">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('SeaExport.Anti_terrorismShipping')">
                <el-checkbox-group v-model="warningConfig.checkOptionsList" style="width: 405px">
                  <el-checkbox label="Manifest" style="display: block;">{{ $t('SeaExport.ManifestReceipt') }}</el-checkbox>
                  <el-checkbox label="VGM" style="display: block;">{{ $t('SeaExport.VgmReceipt') }}</el-checkbox>
                  <el-checkbox label="AMS" style="display: block;">{{ $t('SeaExport.AmsReceipt') }}</el-checkbox>
                  <el-checkbox label="ACI" style="display: block;">{{ $t('SeaExport.AciReceipt') }}</el-checkbox>
                  <el-checkbox label="AFR" style="display: block;">{{ $t('SeaExport.AfrReceipt') }}</el-checkbox>
                  <el-checkbox label="ENS" style="display: block;">{{ $t('SeaExport.EnsReceipt') }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column content-wrapper">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_SetAlertNotificationObject') }}</span>
              <div style="margin-left: 10px">
                <div>
                  <el-checkbox v-model="warningConfig.designatedPosition">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
                </div>
                <el-checkbox-group v-model="warningConfig.notifierRolesList" style="margin-left: 10px">
                  <el-checkbox style="margin-top: 10px" label="1">{{ $t('SeaExport.Operation') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="2">{{ $t('SeaExport.Sales') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="3">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="4">{{ $t('SeaExport.Documents') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="5">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="6">{{ $t('SeaExport.SalesOfGoods') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="10">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="12">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="7">{{ $t('SeaExport.UserDefinedRole1') }}</el-checkbox>
                  <el-checkbox style="margin-top: 10px" label="8">{{ $t('SeaExport.UserDefinedRole2') }}</el-checkbox>
                </el-checkbox-group>
                <div style="margin-top: 10px">
                  <el-checkbox v-model="warningConfig.designatedPersonnel" @change="warningConfig.notifierIdsList=[]">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_User"
                    :fields="['chineseName']"
                    :disabled="!warningConfig.designatedPersonnel"
                    :callback-params="{key:'userList'}"
                    callback-method-type="value"
                    tag-value="userId"
                    tag-name="chineseName"
                    :filter-tag-names="['chineseName']"
                    :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                    :default-multiple-value="warningConfig.notifierIdsList"
                    multiple
                    filterable
                    style="width:205px;margin-top: 10px"
                    options-width="230px"
                    @parentCallBack="p=>{warningConfig.notifierIdsList=p.value}"
                  />
                </div>
              </div>
              <span style="margin-top: 10px" class="title">{{ $t('CargoMsg.Cargo_ReminderModes') }}</span>
              <div>
                <el-checkbox v-model="warningConfig.enableMail">{{ $t('Viewer.email') }}</el-checkbox>
                <el-checkbox v-model="warningConfig.enableWeChat">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="close">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getWarningConfig, saveWarningConfig } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import * as commonUtil from '@/utils/commonUtil'

export default {
  name: 'AmsVgmReminderForm',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      warningConfig: {
        checkOptionsList: [],
        designatedPosition: false,
        notifierRolesList: [],
        designatedPersonnel: false,
        notifierIdsList: [],
        enableMail: false,
        enableWeChat: false,
        enableEnterpriseWechat: false,
        warningType: 'AMS'
      },
      fullscreenLoading: null,
      selectTypeNames: TYPE_NAMES
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      getWarningConfig({ warningType: this.warningConfig.warningType }).then((res) => {
        const data = res.data
        this.warningConfig = data
        this.warningConfig.checkOptionsList = data.checkOptions ? data.checkOptions.split(',') : []
        this.warningConfig.notifierRolesList = data.notifierRoles ? data.notifierRoles.split(',') : []
        this.warningConfig.notifierIdsList = commonUtil.splitToNumberArray(data.notifierIds, ',')
      })
    },
    async commitHandler() {
      this.fullscreenLoading = getLoading()
      try {
        this.warningConfig.warningType = 'AMS'
        await saveWarningConfig(this.warningConfig).then()
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('reload')
        this.close()
      } finally {
        this.fullscreenLoading.close()
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
  .reminder-form {
    .el-dialog__body {
      padding: 10px !important;
    }
    .el-icon-warning-outline{
      font-size: 16px;
      margin-right: 5px;
      color: orange;
    }
    /* 未访问的链接 */
    a:link {
      color: #FF0000;
    }

    /* 已访问的链接 */
    a:visited {
      color: $--color-primary;
    }

    /* 鼠标悬停链接 */
    a:hover {
      color: orange;
    }

    /* 已选择的链接 */
    a:active {
      color: #0000FF;
    }
    .primary-text {
      color: $--color-primary;
    }
    .el-icon-warning{
      font-size: 17px;
      color: $--color-primary;
      margin-right: 5px;
    }
    .warning-title{
      font-size: 16px;
    }
    .content-wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      width: 500px !important;
      .custom {
        .el-form-item__content {
          width: auto;
        }
      }

      .el-radio__label{
        font-size: 12px;
      }
      .el-form-item__content {
        width: 405px !important;
        textarea {
          width: 385px;
        }
        .cargo-advance-select-wrapper{
          width: 405px !important;
        }
      }
    }
  }
</style>
